// Sestaveni cesty k origin obrazku pokemona (client/src/assets/pic/pokemons/...)
// z hodnoty PokemonType.img (napr. "/1.png" nebo "/Alolan/1.png") - jedno
// sdilene miste miste drivejsi kopie tehoz require() na 13+ mistech, viz
// docs/superpowers/specs/2026-08-14-pokemon-sprite-mirror-design.md.
export function pokemonImageSrc(img) {
    return require('@/assets/pic/pokemons' + img);
}
